import { render, staticRenderFns } from "./ListPP.vue?vue&type=template&id=28e30ed8&"
import script from "./ListPP.vue?vue&type=script&lang=js&"
export * from "./ListPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports